import { type ActionEvent, Controller } from "@hotwired/stimulus"
import { type TurboBeforeFrameRenderEvent } from "@hotwired/turbo"

import { pushGa4StorageToDataLayer } from "@/helpers/ga4_helper"
import { hideAllLoaders, startPageLoader } from "@/helpers/page_loader"
import { isMobile } from "@/helpers/window_size"

export default class extends Controller {
  private hideLoaders = (e: TurboBeforeFrameRenderEvent): void => {
    const target = e.target as HTMLElement
    if (target.id === "turbo-previous-results" || target.id === "turbo-next-results") {
      hideAllLoaders()
    }
  }

  connect(): void {
    // We do this on `connect` rather than `initialize` because root element is a Turbo stream
    // target that gets replaced when filters change, which counts as new search page load.
    pushGa4StorageToDataLayer()

    document.addEventListener("turbo:before-frame-render", this.hideLoaders)
  }

  disconnect(): void {
    document.removeEventListener("turbo:before-frame-render", this.hideLoaders)
  }

  navigateWithLoader(e: ActionEvent): void {
    const link = e.target as HTMLAnchorElement

    if (link.hasAttribute("target")) {
      if (isMobile()) {
        link.removeAttribute("target")
        startPageLoader()
      }
    } else {
      startPageLoader()
    }
  }
}
